import {Box, Flex, Image, Text} from '@chakra-ui/react'
import StarIcon from '@assets/svgs/exam/star-blue.svg'
import UpgradeSentenceDetail from './UpgradeSentenceDetail'

const SpeakResult = ({
  type,
  speaking,
  explain,
  typeSpeak,
  sentenceDetail,
  highlightText,
  upgradeScore,
  statistics,
  showSentenceDetail,
  styleByTextTag,
  formatFixText,
  showExplainDetail,
}: any) => {
  const isOrigin = type === 'originSpeak'

  return (
    <Box flex={1} bg={'#FAFAFA'} borderRadius={'12px'} p={'20px'}>
      <Flex
        fontSize={'24px'}
        fontWeight={600}
        color={isOrigin ? '#595959' : '#1890FF'}>
        {!isOrigin && <Image src={StarIcon} />}
        {isOrigin
          ? `Bài của bạn: ${statistics.overall.toFixed(1)}`
          : `Bài nâng cấp: ${upgradeScore.toFixed(1)}`}
      </Flex>
      <Box display={'inline'} mt={'20px'} fontSize={'20px'} fontWeight={600}>
        {speaking?.sentences.map((sentence: any, indexSentence: number) => (
          <Text
            as={'span'}
            key={indexSentence}
            className={
              sentenceDetail === sentence.original_sentence ||
              sentenceDetail === sentence.fix_sentence
                ? 'exam-question-speaking'
                : ''
            }
            display={'inline'}
            position={'relative'}
            cursor={sentence.phrases ? 'pointer' : 'auto'}
            sx={
              (sentenceDetail === sentence.original_sentence ||
                sentenceDetail === sentence.fix_sentence) &&
              sentence.phrases
                ? highlightText
                : {}
            }
            pointerEvents={sentenceDetail ? 'none' : 'auto'}
            onClick={() =>
              showSentenceDetail(
                isOrigin ? sentence.original_sentence : sentence.fix_sentence,
                type,
              )
            }>
            {styleByTextTag(
              isOrigin ? sentence.original_sentence : sentence.fix_sentence,
            )}
            {(sentenceDetail === sentence.original_sentence ||
              sentenceDetail === sentence.fix_sentence) &&
              typeSpeak === type &&
              sentence.phrases && (
                <UpgradeSentenceDetail
                  isOrigin={isOrigin}
                  sentence={sentence}
                  explain={explain}
                  showSentenceDetail={showSentenceDetail}
                  formatFixText={formatFixText}
                  showExplainDetail={showExplainDetail}
                />
              )}
          </Text>
        ))}
      </Box>
    </Box>
  )
}

export default SpeakResult
